// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TestOperationSection_titleContainer__hGYIN {
    margin-left: 1rem;
}

.TestOperationSection_accordionHeaderContainer__ANsph {
    width: 100%;
}

.TestOperationSection_infoMessage__aU7fp {
    margin-left: 1rem;
}

.TestOperationSection_noOperationCard__\\+ddT2 {
    background-color: white !important;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    height: 5.2rem;
}

.TestOperationSection_smallColumnsWidthOperation__6XMjq {
    width: 15%;
}

.TestOperationSection_columnsWidthOperation__STGKQ {
    width: 22%;
}

.TestOperationSection_largeColumnsWidthOperation__RhdL0 {
    width: 43%;
}

.TestOperationSection_smallColumnsWidthAssert__TCm1d {
    width: 15.2%;
}

.TestOperationSection_columnsWidthAssert__er3zj {
    width: 21.6%;
}

.TestOperationSection_largeColumnsWidthAssert__a3bTS {
    width: 43.6%;
}

.TestOperationSection_chevron__I3Yw5 {
    cursor: pointer;
}

.TestOperationSection_largeTable__8JlRe {
    width: 90%;
}

.TestOperationSection_operationRow__78n2t {
    border: var(--color-lightGray) solid 0.1rem;
}

.TestOperationSection_addOperationIcon__yzi0d {
    margin-left: 1rem;
}

.TestOperationSection_testSection__LxtNe {
    margin-bottom: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/components/TestReport/TestOperationSection/TestOperationSection.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;IAClC,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":[".titleContainer {\n    margin-left: 1rem;\n}\n\n.accordionHeaderContainer {\n    width: 100%;\n}\n\n.infoMessage {\n    margin-left: 1rem;\n}\n\n.noOperationCard {\n    background-color: white !important;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    height: 5.2rem;\n}\n\n.smallColumnsWidthOperation {\n    width: 15%;\n}\n\n.columnsWidthOperation {\n    width: 22%;\n}\n\n.largeColumnsWidthOperation {\n    width: 43%;\n}\n\n.smallColumnsWidthAssert {\n    width: 15.2%;\n}\n\n.columnsWidthAssert {\n    width: 21.6%;\n}\n\n.largeColumnsWidthAssert {\n    width: 43.6%;\n}\n\n.chevron {\n    cursor: pointer;\n}\n\n.largeTable {\n    width: 90%;\n}\n\n.operationRow {\n    border: var(--color-lightGray) solid 0.1rem;\n}\n\n.addOperationIcon {\n    margin-left: 1rem;\n}\n\n.testSection {\n    margin-bottom: 0.5rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titleContainer": `TestOperationSection_titleContainer__hGYIN`,
	"accordionHeaderContainer": `TestOperationSection_accordionHeaderContainer__ANsph`,
	"infoMessage": `TestOperationSection_infoMessage__aU7fp`,
	"noOperationCard": `TestOperationSection_noOperationCard__+ddT2`,
	"smallColumnsWidthOperation": `TestOperationSection_smallColumnsWidthOperation__6XMjq`,
	"columnsWidthOperation": `TestOperationSection_columnsWidthOperation__STGKQ`,
	"largeColumnsWidthOperation": `TestOperationSection_largeColumnsWidthOperation__RhdL0`,
	"smallColumnsWidthAssert": `TestOperationSection_smallColumnsWidthAssert__TCm1d`,
	"columnsWidthAssert": `TestOperationSection_columnsWidthAssert__er3zj`,
	"largeColumnsWidthAssert": `TestOperationSection_largeColumnsWidthAssert__a3bTS`,
	"chevron": `TestOperationSection_chevron__I3Yw5`,
	"largeTable": `TestOperationSection_largeTable__8JlRe`,
	"operationRow": `TestOperationSection_operationRow__78n2t`,
	"addOperationIcon": `TestOperationSection_addOperationIcon__yzi0d`,
	"testSection": `TestOperationSection_testSection__LxtNe`
};
export default ___CSS_LOADER_EXPORT___;
